import { observer } from 'mobx-react-lite'
import { Fragment, useEffect, useState } from 'react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
const Lines = observer(() => {
  const [moveLInes, setMove] = useState(false)

  const getTitles = () => {
    if (!ContentState.about) return []
    const arr: Array<string> = new Array(
      ContentState.about!.we.lines.list.length * 10,
    )
    return arr.fill('0')
  }

  const firstAnim = () => {
    const lines = document.querySelectorAll('.we-block__dnk-inside')
    let interval = null
    let step = 5

    let current = window.getComputedStyle(lines[0] as Element)
    let leftPos = +current.transform.split(',')[4]

    ;(lines[0] as HTMLElement).style.setProperty(
      'transform',
      `translate3d(${leftPos - step}px, 0 , 0)`,
    )

    requestAnimationFrame(firstAnim)
  }

  const secondAnim = () => {
    const lines = document.querySelectorAll('.we-block__dnk-inside')
    let interval = null
    let step = 10

    let current = window.getComputedStyle(lines[1] as Element)
    let leftPos = +current.transform.split(',')[4]

    ;(lines[1] as HTMLElement).style.setProperty(
      'transform',
      `translate3d(${leftPos + step}px, 0 , 0)`,
    )

    requestAnimationFrame(secondAnim)
  }

  const thirdAnim = () => {
    const lines = document.querySelectorAll('.we-block__dnk-inside')
    let interval = null
    let step = 5

    let current = window.getComputedStyle(lines[2] as Element)
    let leftPos = +current.transform.split(',')[4]

    ;(lines[2] as HTMLElement).style.setProperty(
      'transform',
      `translate3d(${leftPos - step}px, 0 , 0)`,
    )

    requestAnimationFrame(thirdAnim)
  }

  useEffect(() => {
    let interval1: any = null,
      interval2: any = null,
      interval3: any = null

    const lines = document.querySelectorAll('.we-block__dnk-inside')

    if (moveLInes) {
      lines.forEach((l) => l.classList.add('anim'))

      // interval1 = setInterval(() => {
      //   firstAnim()
      //   secondAnim()
      //   thirdAnim()
      // }, 0)
      // requestAnimationFrame(firstAnim)
      // requestAnimationFrame(secondAnim)
      // requestAnimationFrame(thirdAnim)
    } else {
      lines.forEach((l) => l.classList.remove('anim'))

      //clearInterval(interval1)
    }

    return () => {
      clearInterval(interval1)
    }
  }, [moveLInes])

  useEffect(() => {
    setTimeout(() => {
      const track = document.querySelector('.we-block__dnk'),
        titleTrack = document.querySelector('.we-block__dnk-title'),
        itemBlock = document.querySelector('.we-block__dnk-block'),
        itemsTrack = document.querySelectorAll('.we-block__dnk-inside')
      if (!track) return

      const observerTrack = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            itemsTrack.forEach((i, idx) => {
              setMove(true)
            })
          } else {
            //setMove(false)
            // ;(itemsTrack[0] as HTMLElement).style.setProperty(
            //   'transform',
            //   `translateX(${
            //     0 - (itemBlock as any).getBoundingClientRect().width / 2
            //   }px)`,
            // )
            // ;(itemsTrack[1] as HTMLElement).style.setProperty(
            //   'transform',
            //   `translateX(-${
            //     (itemsTrack[0] as HTMLElement).getBoundingClientRect().width -
            //     (itemBlock as any).getBoundingClientRect().width
            //   }px)`,
            // )
            // ;(itemsTrack[2] as HTMLElement).style.setProperty(
            //   'transform',
            //   `translateX(${
            //     0 -
            //     (itemBlock as any).getBoundingClientRect().width / 2 -
            //     (itemBlock as any).getBoundingClientRect().width / 1.8
            //   }px)`,
            // )
          }
        },
        {
          root: null,
          threshold: 0.1,
        },
      )

      observerTrack.observe(track)
    }, 100)
  }, [ContentState.about?.we.lines])

  if (!ContentState.about?.we.lines.icons || !ContentState.about.we.lines.list)
    return <></>

  return (
    <div className="we-block__dnk">
      <div className="we-block__dnk-container">
        <div
          className="we-block__dnk-title over"
          dangerouslySetInnerHTML={{
            __html: ContentState.about.we.lines.title,
          }}
        ></div>
        <div className="we-block__dnk-lines">
          <div className="we-block__dnk-line">
            <div className="we-block__dnk-inside">
              {getTitles().map((t, id) => (
                <div className="we-block__dnk-block" key={id}>
                  {ContentState.about?.we.lines.list?.map(
                    (t: any, i: number) => (
                      <Fragment key={i}>
                        <div className="we-block__dnk-icon">
                          <img src={ContentState.about?.we.lines.icons[i]} />
                        </div>
                        <div className="we-block__dnk-text">{t}</div>
                      </Fragment>
                    ),
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="we-block__dnk-line">
            <div className="we-block__dnk-inside">
              {getTitles().map((t, id) => (
                <div className="we-block__dnk-block" key={id}>
                  {ContentState.about?.we.lines.list?.map(
                    (t: string, i: number) => {
                      return (
                        <Fragment key={i}>
                          <div className="we-block__dnk-icon">
                            <img src={ContentState.about?.we.lines.icons[i]} />
                          </div>
                          <div className="we-block__dnk-text">{t}</div>
                        </Fragment>
                      )
                    },
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="we-block__dnk-line">
            <div className="we-block__dnk-inside">
              {getTitles().map((t, id) => {
                const lines = JSON.parse(
                  JSON.stringify(ContentState.about?.we.lines.list),
                )
                return (
                  <div className="we-block__dnk-block" key={id}>
                    {lines.reverse()?.map((t: string, i: number) => {
                      return (
                        <Fragment key={i}>
                          <div className="we-block__dnk-icon">
                            <img
                              src={
                                ContentState.about?.we.lines.icons[
                                  lines.length-1 - i
                                ]
                              }
                            />
                          </div>
                          <div className="we-block__dnk-text">{t}</div>
                        </Fragment>
                      )
                    })}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default Lines
